import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import clsx from 'clsx';
import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { toJS } from 'mobx';
import { RATE_SEGMENT_INFO } from 'global/utils/RateSegmentHelper';
import { createStyles } from './styles';

const FiltersPanel = observer((): JSX.Element => {
  const {
    favoriteProposalsStore: { filter, updateFilter },
    userStore: { userRoles },
  } = useRootStore();

  const convertedUserRoles = userRoles.map((role) => toJS(role)).slice();

  const classes = createStyles();

  const keyPressHandler = (e: React.KeyboardEvent<HTMLElement> | KeyboardEvent): void => {
    if (e.keyCode === 13) {
      updateFilter(filter);
    }
  };

  const onSetActiveFilter = (ownFilter: RateSegment | 'ALL'): void => {
    updateFilter(ownFilter);
  };

  const filterCards = Object.entries(RATE_SEGMENT_INFO).map(([filterKey, { label, userRoles: supportedRoles }]) => {
    const showFilterCard =
      supportedRoles.length === 0 || convertedUserRoles.some((role) => supportedRoles.includes(role));

    return (
      <React.Fragment key={filterKey}>
        {showFilterCard && (
          <li
            role="menuitem"
            tabIndex={0}
            className={clsx(
              classes.filterCard,
              classes[`filterCard_${filterKey as RateSegment | 'ALL'}`],
              filterKey === filter && classes[`filterCardActive_${filterKey}`],
            )}
            onClick={(): void => onSetActiveFilter(filterKey as RateSegment)}
            onKeyDown={keyPressHandler}
          >
            <h6 className={classes.filterCardTitle}>{label}</h6>
          </li>
        )}
      </React.Fragment>
    );
  });

  return (
    <ul className={classes.filtersList} role="menu">
      {filterCards}
    </ul>
  );
});

export default FiltersPanel;
